import {DeepLinkActionBase} from "../deep-link-action-base";
import {AreaType} from "@sparkware/uc-sdk-core";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../common/const/casinofied-analytics-consts";
import {OPEN_SAFEZONE_SOURCE_VALUES} from "../../../safezone/safezone.service.interface";

export class ControlCenterDeeplinkAction extends DeepLinkActionBase {
  async execute() {

    if(!this.services.user.isAuthorized){
      await this.services.user.openLogin({}, this.descriptor.marketingParams);
    }

    if (!this.services.safezone.isEnabled) {
      return Promise.reject('Control center is disabled for logged in user!');
    }

    this.services.appLauncher.openControlCenterFull({
      businessCorrelationID: this.services.tools.getGuid(),
      channel: {
          area: AreaType.externalClick,
          element: CHANNEL_ELEMENTS.deepLink,
          source: CHANNEL_SOURCE.casinoClient
      },
      appSpecificParameters: {
          source: OPEN_SAFEZONE_SOURCE_VALUES.LOBBY
      }
    });
  }
}
